import { render, staticRenderFns } from "./tendering-notice-detail.vue?vue&type=template&id=3201c03d&scoped=true&"
import script from "./tendering-notice-detail.vue?vue&type=script&lang=js&"
export * from "./tendering-notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./tendering-notice-detail.vue?vue&type=style&index=0&id=3201c03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201c03d",
  null
  
)

export default component.exports